<template>
  <div>
    <!-- Datatable hidden while data is loading -->
    <div v-if="!loading">
    <v-toolbar elevation="0">
      <v-toolbar-title class="primary--text"><h2>Users</h2></v-toolbar-title>
      <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search ..."
        single-line
        hide-details
      >
      </v-text-field>
    </v-toolbar>
      <!-- Datatable -->
      <v-data-table
          :headers="headers"
          :items="userData"
          :search="search"
          class="elevation-1">
        <!-- Row action (edit/delete) -->
        <template v-slot:item.actions="{ item }">
          <v-icon
              small
              class="mr-2"
              @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon
              small
              @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>

      <br/>

      <!-- Load More button -->
      <v-btn v-on:click="loadMore" :disabled="lastPageReached" class="primary mr-10">Load More</v-btn>

      <!-- Service Provider Dialog (create/edit) -->
      <v-dialog
          v-model="dialog"
          max-width="500px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="primary"
              dark
              class="mt-1,5 ml-2"
              v-bind="attrs"
              v-on="on"
          >
            New User
          </v-btn>
        </template>
        <CreateDialog
            v-bind:close-function="closeDialog"
            v-bind:form-title="dialogTitle"
            v-bind:item="editUser"
            v-bind:save-function="saveUser" />
      </v-dialog>

      <!-- Delete confirmation dialog -->
      <v-dialog v-model="deleteDialog" max-width="500px">
        <DeleteDialog
          v-bind:close-delete="closeDialog"
          v-bind:delete-item-confirm="deleteUser"></DeleteDialog>
      </v-dialog>
    </div>

    <!-- Display loader when fetching data -->
    <div v-if="loading">
      <Loading/>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading';
import CreateDialog from "@/components/users/CreateDialog";
import DeleteDialog from "@/components/users/DeleteDialog";
import { doc, getFirestore, addDoc, collection, getDocs, deleteDoc, setDoc, limit, startAfter, query }from "firebase/firestore";
const db = getFirestore();

/** Utility method used to clean up after dialogs */
async function cleanupAfterDialog(context) {
  context.editUser = {};
  context.query = null;
  context.userData = [];
  await context.loadMore();
  context.closeDialog();
}

export default {
  name: 'Users',
  components: {DeleteDialog, CreateDialog, Loading },
  data() {
    return {
      dialog: false,
      dialogTitle: 'New User',
      deleteDialog: false,
      editUser: {},
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Company', value: 'companyName' },
        { text: 'Card', value: 'hasCard' },
        { text: 'Sage', value: 'isSage' },
        { text: 'VAT', value: 'vatNo' },
        { text: 'Email', value: 'emailAddress' },
        { text: 'Mobile', value: 'mobile' },
        { text: 'Actions', value: 'actions', sortable: true }
      ],
      userData: [],
      options: {
        page: 1,
        pageSize: 500
      },
      loading: false,
      query: null,
      lastVisible: null,
      search: '',
      lastPageReached: false
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.deleteDialog = false;
      this.dialogTitle = 'New User';

      this.$nextTick(() => {
        Object.assign(this.editUser, {});
      })
    },
    async saveUser() {
      if (!this.editUser.id) {
        addDoc(collection(db, 'users'), this.editUser)
        .then( async () => {
          await cleanupAfterDialog(this);
        });
      } 
      else {
        setDoc(doc(db, 'users', this.editUser.id), this.editUser, { merge: true })
        .then( async () => {
          await cleanupAfterDialog(this);
        });
      }
      this.dialog = false;
    },
    async deleteUser() {
      deleteDoc(doc(db, 'users', this.editUser.id))
      .then( async () => {
        await cleanupAfterDialog(this);
      });
    },
    async editItem(user) {
      Object.assign(this.editUser, user);
      console.log(user);
      this.dialogTitle = "Edit User";
      this.dialog = true;
    },
    async deleteItem(user) {
      Object.assign(this.editUser, user);
      this.deleteDialog = true;
    },
    mapData(user, userId) {
      return {
        id: userId,
        name: user.firstName + ' ' + user.lastName,
        firstName: user.firstName,
        lastName: user.lastName,
        companyName: user.companyName ? user.companyName : user.firstName + ' ' + user.lastName,
        vatNo: user.vatNo ? user.vatNo : 'No',
        emailAddress: user.emailAddress,
        mobile: user.mobile,
        hasCard: user.card && user.card != 'No' ? 'Yes' : 'No',
        card: user.card && user.card != 'No' ? {
          registrationId: user.card.registrationId,
        }: 'No',
        isSage: user.sageId ? 'Yes' : 'No',
        sageId: user.sageId,
        scope: user.scope
      }
    },

    async getNextData(options) {
      this.loading = true;
      this.options = options;
      const { pageSize } = options;
      if (!this.query) {
        this.query = query(collection(db, 'users'), limit(pageSize));
      }

      try{
        const currentQuery = await getDocs(this.query);
        this.lastVisible = currentQuery.docs[currentQuery.docs.length -1];

        currentQuery.forEach((res) => {
          this.userData.push(this.mapData(res.data(), res.id));
        });
        if (currentQuery.size < pageSize) {
          this.lastPageReached = true;
        }
        this.query = query(collection(db, 'users'), startAfter(this.lastVisible), limit(pageSize));
        this.loading = false;
      }
      catch(e){
        console.log(e);
        this.loading = false;
      }
    },

    async loadMore() {
      await this.getNextData(this.options);
    }
  },
  async mounted() {
    if (this.userData.length === 0) {
      this.loadMore();
    }
  }
}
</script>

<style scoped>

</style>